<template>
  <a :href="card.link" class="Product relative block EnjoymentSliderCard">
    <aw-img
      :image="card.size14__image"
      src="https://dummyimage.com/724x1000.jpg"
      class="rounded-ambi relative NotScale"
      size="724x1000x8"
    />

    <div class="ProductOverlay -Gradient absolute inset-0 mx-0 rounded-ambi"></div>
    <!-- <div
      v-if="card.type === 'Nominal'"
      class="absolute inset-0 mx-0 rounded-ambi"
      style="background: #f3f3f3"
    ></div> -->

    <div class="ProductData">
      <div class="ProductCategory -Closer text-p3 inline-flex items-center gap-x-1">
        <span
          v-for="category in card.categories"
          :key="category.icon"
          :title="category.name"
          class="FilterTag -Card"
        >
          {{ category.name }}
        </span>
      </div>
      <div class="ProductName -Closer">
        <div class="text-h3 lg:text-h2 mb-2" v-html="card.name"></div>
        <div class="text-p1" v-if="card.type === 'Nominal'">{{ $t('Uplatnitelná všude') }}</div>
        <div class="text-p1" v-else-if="card.price">{{ card.price.price_formatted }}</div>
        <div class="text-p1" v-else-if="card.min_price">{{ card.min_price.price_formatted }}</div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.-Nominal > img {
  // @apply opacity-50;
}
</style>
